import JSZip from '@progress/jszip-esm';

export default function createZip() {
    return new JSZip();
}
